import React, { useCallback, useContext, useMemo, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Tab } from 'components';
import PostList from './PostList';
import {
  PostBox,
  PostHeader,
  PostIcons,
  PostInput,
  PreviewPost,
} from './Home.style';
import DynModel from 'components/Modal';
import ModalContent from './Content';
import { useTranslation } from 'react-i18next';
import { Helmet } from 'react-helmet';
import { ReactComponent as Photo } from 'assert/images/Home/photo.svg';
import { ReactComponent as Vedio } from 'assert/images/Home/video.svg';
import { ReactComponent as Document } from 'assert/images/Home/document.svg';
import { AuthContext } from 'router/AuthProvider';
import LoginNotification from 'pages/auth/LoginNotification';
import clsx from 'clsx';

const AddProfile = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { t } = useTranslation();
  const { isLoggedIn } = useContext(AuthContext);

  const [postModalOpen, setPostOpenModal] = useState(false);
  const [modalTitle, setModalTitle] = useState(true);
  const [isLoginNotificationOpen, setIsLoginNotificationOpen] = useState(false);

  const IconList = [
    { icon: <Photo className="icon" />, title: 'HomePage.Photo', type: 'img' },
    { icon: <Vedio className="icon" />, title: 'HomePage.Video', type: '' },
    {
      icon: <Document className="icon" />,
      title: 'HomePage.Document',
      type: '',
    },
  ];

  const tablist = [
    { label: t('HomePage.Explore'), value: 0 },
    { label: t('HomePage.Following'), value: 1 },
  ];

  const selectedTabIndex = useMemo(() => {
    return location.pathname === '/following' ? 1 : 0;
  }, [location.pathname]);

  const TabChange = (tabIndex) => {
    const targetPath = tabIndex === 1 ? '/following' : '/';
    if (location.pathname !== targetPath) {
      navigate(targetPath);
    }
  };

  const closePostModal = useCallback(() => {
    setPostOpenModal(false);
    setModalTitle(true);
  }, []);

  return (
    <>
      <Helmet>
        <title>
          Home | WafyNet - Explore User Posts, Photos, Videos & Updates
        </title>
        <meta
          name="description"
          content="Stay connected with the Wafynet community. Explore user-shared posts, photos, videos, documents, and updates from around the world."
        />
      </Helmet>
      <PostHeader>
        <PostBox>
          <div
            className="upload-block"
            onClick={() =>
              isLoggedIn
                ? setPostOpenModal(true)
                : setIsLoginNotificationOpen(true)
            }
          >
            <PostInput>{t('HomePage.LetUsKnow')}</PostInput>
            <PostIcons className="PostIcons">
              {IconList.map((data, index) => (
                <PreviewPost key={index} className="PreviewPost">
                  {data.icon}
                  <div className="icon-title">{t(data.title)}</div>
                </PreviewPost>
              ))}
            </PostIcons>
          </div>
          <DynModel
            modalchanges="postModal"
            openModal={postModalOpen}
            modelTitle={
              modalTitle ? t('HomePage.CreatePost') : t('homepage.Edit Post')
            }
            handleCancelModal={closePostModal}
            maxWidth={false}
            fullWidth={false}
            content={
              <ModalContent
                closePostModal={closePostModal}
                modalTitle={modalTitle}
              />
            }
          />
        </PostBox>

        <div
          className={clsx(
            !isLoggedIn && 'hide-post-tab-label',
            'home-post-tab'
          )}
        >
          <Tab
            tabList={isLoggedIn ? tablist : tablist.slice(0, 1)}
            handleTabChange={TabChange}
            callbackTabIndex={() => selectedTabIndex}
            isLargeTab
          />
        </div>

        {location.pathname === '/following' ? (
          <PostList
            view="following"
            createModalOpen={postModalOpen || isLoginNotificationOpen}
          />
        ) : (
          <PostList
            view="nonfollowers"
            createModalOpen={postModalOpen || isLoginNotificationOpen}
          />
        )}

        <LoginNotification
          isLoginNotificationOpen={isLoginNotificationOpen}
          handleUpdateModal={() => setIsLoginNotificationOpen(false)}
        />
      </PostHeader>
    </>
  );
};

export default AddProfile;
